import { IUserChemicalExposureLogItem } from '../models/chemical-exposure.model';

export function formatChemicalExposureAmount(item?: IUserChemicalExposureLogItem | null): string {
  if (item?.quantityWithdrawn == null) {
    return '';
  }

  const unit = item.quantityType?.name;
  return unit ? `${item.quantityWithdrawn} ${unit}` : `${item.quantityWithdrawn}`;
}
